import React from 'react';
import { connect } from 'react-redux';
import { faTrash, faDownload, faUpload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { removeOrigin } from '../../../../../helpers/urls';
import { deleteImage } from '../../actions';

import RoundButton from '../../../../../components/RoundButton';

import style from './style.module.scss';

const ActionButtons = ({
  data,
  imageKey,
  selectFile,
  deleteImageAction,
  // Custom icon mode props (when provided, uses custom mode instead of Redux)
  customIconData,
  hasUploaded,
  deleteCustomIcon,
}) => {
  // Custom icon mode - show upload always, download/delete only when uploaded
  if (customIconData !== undefined) {
    return (
      <div className={style.actionButtonsContainer}>
        <RoundButton title="Upload" className={style.actionBtn} onClick={selectFile}>
          <FontAwesomeIcon icon={faUpload} className="align-middle" />
        </RoundButton>
        {hasUploaded && (
          <>
            <a
              className={style.actionBtn}
              title="Download"
              href={removeOrigin(customIconData.srsIconRawUrl || customIconData.srsIconUrl)}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faDownload} className="align-middle" />
            </a>
            <RoundButton title="Delete" className={style.actionBtn} onClick={deleteCustomIcon}>
              <FontAwesomeIcon icon={faTrash} className="align-middle" />
            </RoundButton>
          </>
        )}
      </div>
    );
  }

  // Default mode (Redux-connected) - only show when there's data
  const isEmpty = Object.values(data || {}).every((val) => !val);

  if (isEmpty) {
    return null;
  }

  const downloadUrl = data[`${imageKey}RawUrl`] || data[`${imageKey}Url`];

  return (
    <div className={style.actionButtonsContainer}>
      <RoundButton title="Upload" className={style.actionBtn} onClick={selectFile}>
        <FontAwesomeIcon icon={faUpload} className="align-middle" />
      </RoundButton>
      {downloadUrl && (
        <a
          className={style.actionBtn}
          title="Download"
          href={removeOrigin(downloadUrl)}
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faDownload} className="align-middle" />
        </a>
      )}
      <RoundButton title="Delete" className={style.actionBtn} onClick={deleteImageAction}>
        <FontAwesomeIcon icon={faTrash} className="align-middle" />
      </RoundButton>
    </div>
  );
};

export default connect(
  ({ graphics: { sections, selectedInd } }) => ({
    data: sections[selectedInd]?.data,
    imageKey: sections[selectedInd]?.key,
  }),
  { deleteImageAction: deleteImage },
)(ActionButtons);
